import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import s from './index.module.scss';

const id = MODAL_IDS.fpg_assets_warning_modal;

export const FpgAssetsWarningModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

const Modal = () => {
  const { closeModal } = useModal();
  const { t } = useTranslation('fundraising');

  const content = (
    <div className={classnames(s.modal, 'scr_modal_grid')}>
      <div className={classnames(s.title, 'f-h2 f-500')}>{t('fpg_asset_warn.title')}</div>
      <div className={s.content}>
        <div className="f-16-24">
          {t('fpg_asset_warn.description')}
          <ul className={s.list}>
            <li>{t('fpg_asset_warn.bank_statements')}</li>
            <li>{t('fpg_asset_warn.investment_statements')}</li>
            <li>{t('fpg_asset_warn.property_records')}</li>
            <li>{t('fpg_asset_warn.vehicle_documents')}</li>
            <li>{t('fpg_asset_warn.share_certificates')}</li>
            <li>{t('fpg_asset_warn.loan_agreements')}</li>
            <li>{t('fpg_asset_warn.life_policies')}</li>
            <li>{t('fpg_asset_warn.trust_documentation')}</li>
            <li>{t('fpg_asset_warn.ip_certificates')}</li>
            <li>{t('fpg_asset_warn.valuations')}</li>
            <li>{t('fpg_asset_warn.crypto_statements')}</li>
            <li>{t('fpg_asset_warn.liabilities_documentation')}</li>
          </ul>
        </div>
      </div>
    </div>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
